export default __webpack_public_path__ + "static/media/customized.a5a56835.svg";